import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import 'bootstrap/dist/css/bootstrap.min.css';
import { registerUser } from '../../../services/authApi';
import { trackEvent } from '../../../utils/newrelic_utils';

const FormularioRegistroEntrenador = () => {
  const formik = useFormik({
    initialValues: {
      nombre: '',
      apellido: '',
      email: '',
      contraseña: '',
      confirmarContraseña: '',
      codigoEntrenador: '',
      experiencia: '',
      deporte: '',
    },
    validationSchema: Yup.object({
      nombre: Yup.string().required('El nombre es requerido'),
      apellido: Yup.string().required('El apellido es requerido'),
      email: Yup.string().email('Email inválido').required('El email es requerido'),
      contraseña: Yup.string().min(6, 'La contraseña debe tener al menos 6 caracteres').required('La contraseña es requerida'),
      confirmarContraseña: Yup.string()
        .oneOf([Yup.ref('contraseña'), null], 'Las contraseñas deben coincidir')
        .required('La confirmación de contraseña es requerida'),
      codigoEntrenador: Yup.string(),
      experiencia: Yup.string().required('La experiencia es requerida'),
      deporte: Yup.string().required('El deporte es requerido'),
    }),
    onSubmit: async (values) => {
      try {
        const datosUsuario = {
          nombre: values.nombre,
          apellido: values.apellido,
          email: values.email,
          contraseña: values.contraseña,
          experiencia: values.experiencia,
          deporte: values.deporte,
        };

        await registerUser(datosUsuario);
        trackEvent('TrainerRegistration', false, null, {
          status: 'success',
          userEmail: values.email,
        });

        formik.setStatus({ success: 'Registro exitoso' });
      } catch (error) {
        trackEvent('TrainerRegistration', true, error.message, {
          status: 'error',
          userEmail: values.email,
        });

        formik.setStatus({ error: 'Hubo un error al registrar al entrenador' });
      }
    },
  });

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-6">
          <h2 className="mb-4">Registro de Entrenador</h2>
          <form onSubmit={formik.handleSubmit}>
            <div className="form-group">
              <label htmlFor="nombre">Nombre</label>
              <input
                type="text"
                className="form-control"
                id="nombre"
                name="nombre"
                {...formik.getFieldProps('nombre')}
              />
              {formik.touched.nombre && formik.errors.nombre ? (
                <div className="text-danger">{formik.errors.nombre}</div>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="apellido">Apellido</label>
              <input
                type="text"
                className="form-control"
                id="apellido"
                name="apellido"
                {...formik.getFieldProps('apellido')}
              />
              {formik.touched.apellido && formik.errors.apellido ? (
                <div className="text-danger">{formik.errors.apellido}</div>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="email">Correo Electrónico</label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                {...formik.getFieldProps('email')}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="text-danger">{formik.errors.email}</div>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="contraseña">Contraseña</label>
              <input
                type="password"
                className="form-control"
                id="contraseña"
                name="contraseña"
                {...formik.getFieldProps('contraseña')}
              />
              {formik.touched.contraseña && formik.errors.contraseña ? (
                <div className="text-danger">{formik.errors.contraseña}</div>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="confirmarContraseña">Repetir Contraseña</label>
              <input
                type="password"
                className="form-control"
                id="confirmarContraseña"
                name="confirmarContraseña"
                {...formik.getFieldProps('confirmarContraseña')}
              />
              {formik.touched.confirmarContraseña && formik.errors.confirmarContraseña ? (
                <div className="text-danger">{formik.errors.confirmarContraseña}</div>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="experiencia">Experiencia</label>
              <input
                type="text"
                className="form-control"
                id="experiencia"
                name="experiencia"
                {...formik.getFieldProps('experiencia')}
              />
              {formik.touched.experiencia && formik.errors.experiencia ? (
                <div className="text-danger">{formik.errors.experiencia}</div>
              ) : null}
            </div>

            <div className="form-group">
              <label htmlFor="deporte">Deporte</label>
              <input
                type="text"
                className="form-control"
                id="deporte"
                name="deporte"
                {...formik.getFieldProps('deporte')}
              />
              {formik.touched.deporte && formik.errors.deporte ? (
                <div className="text-danger">{formik.errors.deporte}</div>
              ) : null}
            </div>

            <button type="submit" className="btn btn-primary">
              Siguiente
            </button>
          </form>

          {formik.status?.success && (
            <div className="alert alert-success mt-3">{formik.status.success}</div>
          )}

          {formik.status?.error && (
            <div className="alert alert-danger mt-3">{formik.status.error}</div>
          )}
        </div>

        <div className="col-md-6 d-flex align-items-center justify-content-center">
          <div className="bg-light d-flex align-items-center justify-content-center" style={{ width: '100%', height: '400px' }}>
            <img
              src="https://via.placeholder.com/200"
              alt="Imagen de registro"
              style={{ maxWidth: '100%', maxHeight: '100%' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormularioRegistroEntrenador;
